export default "__VITE_ASSET__2o2zU0lD3fmgn3MOGobWsw__"